import { render, staticRenderFns } from "./userBrowseRecordDetail.vue?vue&type=template&id=3252cd60&lang=html"
import script from "./userBrowseRecordDetail.vue?vue&type=script&lang=js"
export * from "./userBrowseRecordDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports